import { GeneralHttpResponse } from "../types/genericTypes";
import axios from "axios";
import env from "react-dotenv";

export const getEstadisticasUsuarioNormalHttp = async (datos?: any) => {
  try {
    const response = await axios.get(`${env.API_URL}/getEstadisticasUsuarioNormal`, {
      params: datos,
    });
    return response?.data?.data || response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getEstadisticasComprasHttp = async () => {
  try {
    const response = await axios.get(`${env.API_URL}/getEstadisticasCompras`);
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
